import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Placeholder from "../../components/utility/Placeholder";

/**
 * DashboardTitle: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Renders the dashboard title conditionally
 * if the profile information is ready
 *
 * @param {*} props
 */
const DashboardTitle = props => (
  <h2>
    <Placeholder type="textRow" ready={!props.isLoading}>
      <FormattedMessage
        id="start.welcome"
        description="Welcome message on start page"
        values={{
          firstName: props.firstName,
          lastName: props.lastName
        }}
      />
    </Placeholder>
  </h2>
);

DashboardTitle.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired
};

export default DashboardTitle;



// WEBPACK FOOTER //
// ./src/modules/dashboard/DashboardTitle.js